import {
	parseAsBoolean,
	useQueryState,
	parseAsString,
	useQueryStates,
} from 'nuqs'

export function useGameTypeSelector() {
	const [gameType, setGameType] = useQueryStates({
		gameType: parseAsString.withDefault(''),
	})

	const [popular, setPopular] = useQueryState(
		'popular',
		parseAsBoolean.withDefault(false),
	)

	return {
		gameType,
		setGameType,
		popular,
		setPopular,
	}
}
